import axios from 'axios';

const instance = axios.create({
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json',
  },
});

const fileInstance = axios.create({
  timeout: 20000,
  responseType: 'blob',
});

const getDataObjInFile = (file) => new Promise((resolve, reject) => {
  const fr = new FileReader();
  fr.onload = (e) => resolve(JSON.parse(e.target.result));
  fr.onerror = reject;
  fr.readAsText(file);
});

// request 攔截器
const onRequest = (config) => config;

// response 攔截器
const onResponse = async (response) => {
  // @const {Object} responseData 回應的資料
  const responseData = response.data;
  // 如果有errorCode，則回傳自定義的error物件
  if (responseData.ErrorCode) {
    return {
      errorStatus: responseData.ErrorCode || responseData.errorCode,
      code: responseData.ErrorCode || responseData.errorCode,
      message: responseData.Message || responseData.message,
    };
  }
  return response;
};
const onError = async (err) => {
  // @const {Number} status error狀態碼
  // @let {Object} errorObject error物件
  const { status, data } = err.response;
  let errorObject = err.response.data.error;
  let errMsg = data.Message || data.message;

  console.log({ err });

  errorObject = {
    // @param {Number} errorStatus error的http狀態碼
    // @param {Number} code http狀態碼
    // @param {string} message 錯誤訊息
    errorStatus: status,
    code: status,
    message: errMsg,
  };

  // fileInstance回傳的data會是blob type, 需先讀檔轉成json格式才可取錯誤訊息
  if (err.request.responseType === 'blob') {
    const dataJson = await getDataObjInFile(data);
    errMsg = dataJson.Message || dataJson.message;
  } else {
    errMsg = data.Message || data.message;
  }

  errorObject.message = errMsg;

  return errorObject;
};

instance.interceptors.request.use(onRequest);
fileInstance.interceptors.request.use(onRequest);

instance.interceptors.response.use(onResponse, onError);
fileInstance.interceptors.response.use(onResponse, onError);

// export default instance;
export {
  instance,
  fileInstance,
};
